import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionQuotationPage_QuotationInfo_Init_Mutation = graphql(`
  mutation MissionQuotationPage_QuotationInfo_Init(
    $missionId: Id!
    $quotationInfo: QuotationInfoInput!
    $templateId: Id
    $title: NonEmptyString!
    $versionData: VersionDataInput
  ) {
    initQuotationInfo(
      missionId: $missionId
      quotationInfo: $quotationInfo
      templateId: $templateId
      title: $title
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type QuotationInfoInput = VariablesOf<
  typeof MissionQuotationPage_QuotationInfo_Init_Mutation
>['quotationInfo'];

export type QuotationInfo_Init_Result = ResultOf<
  typeof MissionQuotationPage_QuotationInfo_Init_Mutation
>;

export const useInitQuotationInfoMutation = () =>
  useGraphQLMutation(MissionQuotationPage_QuotationInfo_Init_Mutation);
